import * as React from 'react';

import classNames from 'classnames';

import {CloseButton} from 'shells/button/close-button/close-button';
import {CoreEntityConfirmationDialog} from 'shells/core-entity-confirmation-dialog/core-entity-confirmation-dialog';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import styles from './source-widget.module.css';

type Props = {
    id: string;
    name: string;
    additionalInfo?: string;
    onRemoveSource: (sourceId: string) => void;
    hasHorizontalMargin?: boolean;
};

export function SourceRowReadState(props: Props) {
    const {hasHorizontalMargin = true, onRemoveSource} = props;
    const [isRemoveConfirmationOpen, setIsRemoveConfirmationOpen] = React.useState<boolean>(false);
    const removeButtonRef = React.useRef<HTMLElement | null | undefined>(null);

    const onConfirmRemoveSource = React.useCallback(() => {
        setIsRemoveConfirmationOpen(false);
        onRemoveSource(props.id);
    }, [props.id, onRemoveSource]);

    const onCancelRemoveSource = React.useCallback(() => {
        setIsRemoveConfirmationOpen(false);
    }, []);

    return (
        <div
            className={classNames(styles['source-row'], {
                [styles['source-row--no-horizontal-margin']]: !hasHorizontalMargin,
            })}
        >
            <StackLegacy spacing={8} isHorizontal={true}>
                <Body size='small'>{props.name}</Body>
                {props.additionalInfo && (
                    <Body size='small' color='light'>
                        {props.additionalInfo}
                    </Body>
                )}
            </StackLegacy>
            <div>
                <CloseButton
                    onClick={() => setIsRemoveConfirmationOpen(true)}
                    size={8}
                    variant='dark'
                    getRef={(ref) => {
                        removeButtonRef.current = ref;
                    }}
                />
                {isRemoveConfirmationOpen && (
                    <CoreEntityConfirmationDialog
                        anchor={removeButtonRef.current}
                        type='source'
                        parentEntity='lead'
                        onConfirm={onConfirmRemoveSource}
                        onCancel={onCancelRemoveSource}
                    />
                )}
            </div>
        </div>
    );
}
